/*!
 * Copyright © 2020-2021. Verizon Connect Ireland Limited. All rights reserved.
 */
import { NgModule } from '@angular/core';

import { MapIconRegistryService } from './core/services';

const dsSprite = 'assets/ds-sprite.svg';
const iconsSprite = 'assets/images/sprites/icons-sprite.svg';

@NgModule()
export class AppIconModule {
  constructor(private readonly _mapIconRegistryService: MapIconRegistryService) {
    this._registerIcons();
  }
  private _registerIcons() {
    this._mapIconRegistryService.addSvgIconSetByPath(dsSprite);
    this._mapIconRegistryService.addSvgIconSetByPath(iconsSprite);
  }
}
